import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import { Autoplay, Pagination, Navigation, Keyboard } from 'swiper/modules'
import gsap from 'gsap'

import 'swiper/css' //eslint-disable-line
import 'swiper/css/navigation' //eslint-disable-line
import 'swiper/css/pagination' //eslint-disable-line

export default class extends BaseModule {
  init () {
    const slider = this.el
    const { sliderConfig } = slider.dataset

    const params = {
      default: {
        modules: [Navigation, Keyboard],
        draggable: true,
        grabCursor: true,
        slidesPerView: 1,
        navigation: {
          nextEl: slider.querySelector('.button-next'),
          prevEl: slider.querySelector('.button-prev')
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        on: {
          slideChange: () => {
            const current = document.querySelector('[data-slider-current]')
            const currentIndex = this.swiper.realIndex + 1
            current.innerHTML = currentIndex
            // current.innerHTML = `${currentIndex.toString().padStart(2, '0')}`
          }
        }
      }
    }

    this.swiper = new Swiper(slider, params[sliderConfig])
    gsap.to(slider, {
      opacity: 1,
      duration: 3,
      ease: 'power2.Out'
    })
  }
}
